import { Flex } from '@servicetitan/anvil2';
import { StatusContainer } from '@servicetitan/financing-utils-shared';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import emailIllustration from './email-illustration.svg';
import {
    WorkflowButtonsStore,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';

export const Complete = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const email = applicationData.applicant?.primaryApplicant?.email ?? '';
    const { CloseWithoutConfirmingButton } = WorkflowButtonsStore.useStore();
    const secondLookProviderName = useSecondLookProviderName();

    const message = `A link to complete the ${secondLookProviderName} application was sent to ${email}. Once the application is complete, you can view its status on the application details page.`;

    return (
        <StatusContainer image={emailIllustration} headline="Application sent" message={message}>
            <Flex direction="column" gap="4" style={{ width: '100%' }}>
                <CloseWithoutConfirmingButton appearance="secondary" style={{ width: '100%' }}>
                    Return to Job
                </CloseWithoutConfirmingButton>
            </Flex>
        </StatusContainer>
    );
};
